export const RADIUS_SMALL = "4px";
export const RADIUS_MEDIUM = "6px";

export enum Radius {
  ExtraSmall = "2px",
  Small = "4px",
  Medium = "6px",
  MediumLarge = "8px",
  Large = "10px",
}
